import themes from '../../../../../themes/theme-context';

// MUI theme from theme-context.js (modernLight / modernDark via withTheme / withStyles).
export type AppTheme = (typeof themes)[keyof typeof themes];

const styles = (theme: AppTheme) => ({
  dataGrid: {
    border: `1px solid ${theme.AppBGColor}`,
    '& .ag-theme-material .ag-body-horizontal-scroll': {
      borderWidth: '0px',
    },
    '& .groupHeaderChildren': {
      borderLeft: `1px solid ${theme.AppBGColor} !important`,
      paddingRight: '12px !important',
    },
    '& .ag-theme-material': {
      '& .ag-header-cell': {
        borderColor: theme.gridGroupHeaderBorderColor,
        '& .filterIcon': {
          right: 0,
          zIndex: 3,
          marginRight: 12,
        },
        '&:not(.ag-header-group-cell)': {
          '& .ag-header-cell-resize': {
            width: 16,
            cursor: 'col-resize',
            zIndex: 2,
          },
        },
      },
    },
    // Separator before Spotted Trailers — header only (not body cells).
    '& div[role="columnheader"][col-id="hooksTotal"]': {
      borderRight: `1px solid ${theme.AppBGColor} !important`,
    },
    '& .groupHeaderParentPickup': {
      borderRight: `1px solid ${theme.groupHeaderParent} !important`,
      borderLeft: `1px solid ${theme.groupHeaderParent} !important`,
      '& .ag-header-group-cell-label': {
        justifyContent: 'center',
        flex: 'auto',
      },
    },
  },
});

export default styles;
